import React from 'react';
import styled, { css } from 'styled-components';
import { colors, screen } from '../../../styles/variables';
import { ToastContainer } from 'react-toastify';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
  background-position: center center;

  ${props => props.backgroundImage && css`
    background-color: ${colors.background.default};
    background-image: url(${props.backgroundImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
  `}
`;

const Main = styled.main`
  flex: 1;
  position: relative;

  @media(max-width: ${screen.xs.max}){
    background: #fff;
  }
`;


function Layout({ children }){

  return (
    <Wrapper>
      <Main>
        {children}
      </Main>
      <ToastContainer theme="colored"/>
    </Wrapper>
  );
}

export default Layout;
